"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    checkout: 'Checkout',
    altSpc: 'Alt SPC'
};
